import { observer } from "mobx-react-lite";

import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { useCompanyStore } from "../hooks";

const CompanySetupFooter = observer(
  ({
    compact,
    isDialog,
    canContinueStep,
    nextStep,
    prevStep,
    handleSaveAndExit,
    handleReview,
    handleStart,
  }) => {
    const { t } = useTran();
    const { step } = useCompanyStore();

    return (
      <div className="sticky bottom-0 left-0 right-0 mt-6 flex flex-col gap-3 border-t border-border pt-4 backdrop-blur sm:flex-row sm:items-center sm:justify-between">
        <Button
          type="button"
          variant="outline"
          onClick={prevStep}
          disabled={step === 1}
          className="w-full sm:w-auto"
        >
          {t("Back")}
        </Button>

        {step < 4 && !compact ? (
          <div className="flex w-full flex-col gap-2 sm:ml-auto sm:w-auto sm:flex-row sm:items-center sm:justify-end">
            <Button
              type="button"
              variant="outline"
              onClick={handleSaveAndExit}
              className="w-full sm:w-auto"
            >
              {t("Save & Exit")}
            </Button>
            <Button
              type="button"
              onClick={nextStep}
              disabled={!canContinueStep}
              className="w-full sm:w-auto"
            >
              {t("Continue")}
            </Button>
          </div>
        ) : null}

        {step < 4 && compact ? (
          <Button
            type="button"
            onClick={nextStep}
            disabled={!canContinueStep}
            className="w-full sm:ml-auto sm:w-auto"
          >
            {t("Continue")}
          </Button>
        ) : null}

        {step === 4 ? (
          <div className="flex w-full flex-col gap-2 sm:ml-auto sm:w-auto sm:flex-row sm:items-center sm:justify-end">
            {compact ? (
              <Button
                type="button"
                variant="outline"
                onClick={handleReview}
                className="w-full sm:w-auto"
              >
                {t("Skip for now")}
              </Button>
            ) : (
              <Button
                type="button"
                variant="outline"
                onClick={handleSaveAndExit}
                className="w-full sm:w-auto"
              >
                {t("Save & Exit")}
              </Button>
            )}
            <Button
              type="button"
              onClick={handleReview}
              disabled={!canContinueStep}
              className="w-full sm:w-auto"
            >
              {t("Review")}
            </Button>
          </div>
        ) : null}

        {step === 5 ? (
          <div className="flex w-full flex-col gap-2 sm:ml-auto sm:w-auto sm:flex-row sm:items-center sm:justify-end">
            {compact ? (
              <Button
                type="button"
                onClick={handleStart}
                className="w-full sm:w-auto"
              >
                {isDialog ? t("Update") : t("Let's Start")}
              </Button>
            ) : (
              <Button
                type="button"
                onClick={handleSaveAndExit}
                className="w-full sm:w-auto"
              >
                {t("Save & Exit")}
              </Button>
            )}
          </div>
        ) : null}
      </div>
    );
  },
);

export default CompanySetupFooter;
